'use client';
import useHydrateStore from '@common/application/hooks/useHydrateStore/useHydrateStore';
import { IntlProvider } from 'react-intl';

interface IntlProviderClientProps {
  locale: string;
  messages: Record<string, any>;
  children: React.ReactNode;
}

function IntlProviderClient({ locale, messages, children }: IntlProviderClientProps) {
  useHydrateStore();

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale={'en-GB'}>
      {children}
    </IntlProvider>
  );
}

export default IntlProviderClient;
